import angular from 'angular';
import logger from '../../shared/logger';

export const SearchService = (Restangular, $localStorage) => {
    const getUserSearches = function () {
        return Restangular.all('user')
            .all('search')
            .all('names')
            .get('')
            .catch(err => logger.error(err));
    };

    const getUserSearch = function (index) {
        return Restangular.all('user')
            .one('search', $localStorage.userSearches[index])
            .get('')
            .catch(err => logger.error(err));
    };

    const addUserSearch = function (userSearchBody, update) {
        return Restangular.all('user')
            .all('search')
            .post(userSearchBody)
            .then(() => {
                if (!update) {
                    $localStorage.userSearches.push(userSearchBody.searchName);
                }
            })
            .catch(err => logger.error(err));
    };

    const deleteUserSearch = function (index) {
        return Restangular.one('user')
            .one('search', $localStorage.userSearches[index])
            .customDELETE('')
            .then(() => {
                $localStorage.userSearches.splice(index, 1);
            })
            .catch(err => logger.error(err));
    };

    const getUserCandidates = function () {
        return Restangular.all('user')
            .all('candidateBookmark')
            .all('names')
            .get('')
            .catch(err => logger.error(err));
    };

    const getUserCandidate = function (candiadtesName) {
        return Restangular.all('user')
            .one('candidateBookmark', candiadtesName)
            .get('')
            .catch(err => logger.error(err));
    };

    const addUserCandidates = function (userCandidatesBody, exist) {
        if (exist === true) {
            return Restangular.all('user')
                .all('candidateBookmark')
                .customPUT(userCandidatesBody)
                .catch(err => logger.error(err));
        }

        return Restangular.all('user')
            .all('candidateBookmark')
            .post(userCandidatesBody)
            .then(() => {
                $localStorage.userCandidates.push(userCandidatesBody.name);
            })
            .catch(err => logger.error(err));
    };

    const deleteUserCandidates = function (index) {
        return Restangular.all('user')
            .one('candidateBookmark', $localStorage.userCandidates[index])
            .customDELETE('')
            .then(() => {
                $localStorage.userCandidates.splice(index, 1);
            })
            .catch(err => logger.error(err));
    };

    return {
        getUserSearches,
        getUserSearch,
        addUserSearch,
        deleteUserSearch,
        getUserCandidates,
        getUserCandidate,
        addUserCandidates,
        deleteUserCandidates,
    };
};

angular.module('TALENYA-FE')
    .factory('searchService', SearchService);

